// Gift choices for wishlist items. Each `id` is stored on the item and must
// match the backend's WISHLIST_ICONS set (server.py). We render the real
// (color) emoji so gifts look the same colorful way they do on the guest's own
// phone/keyboard.
export const WISHLIST_ICONS = [
  { id: 'gift', emoji: '🎁' },
  { id: 'heart', emoji: '❤️' },
  { id: 'home', emoji: '🏠' },
  { id: 'plane', emoji: '✈️' },
  { id: 'car', emoji: '🚗' },
  { id: 'baby', emoji: '👶' },
  { id: 'graduation', emoji: '🎓' },
  { id: 'camera', emoji: '📷' },
  { id: 'music', emoji: '🎵' },
  { id: 'dinner', emoji: '🍽️' },
  { id: 'gem', emoji: '💎' },
  { id: 'laptop', emoji: '💻' },
  { id: 'sofa', emoji: '🛋️' },
  { id: 'pet', emoji: '🐾' },
  { id: 'piggy', emoji: '🐷' },
  { id: 'game', emoji: '🎮' },
]

// The color emoji for a stored icon id, falling back to the gift emoji.
export function wishlistEmoji(id?: string) {
  return (WISHLIST_ICONS.find((i) => i.id === id) || WISHLIST_ICONS[0]).emoji
}
